module.exports = {"652924100":"沙雅镇","652924101":"托依堡勒迪镇","652924102":"红旗镇","652924103":"英买力镇","652924104":"沙雅县哈德墩镇","652924105":"古勒巴格镇","652924106":"海楼镇","652924205":"努尔巴格乡","652924206":"塔里木乡","652924207":"盖孜库木乡","652924208":"央塔克协海尔乡","652924400":"新垦农场","652924402":"二牧场","652924403":"沙雅监狱","652924404":"沙雅县工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652924.json
// module id = 2878
// module chunks = 0